import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { cn } from "../../utils/cn";
import { X } from "lucide-react";

export const Sidebar = ({
  visible,
  position = "right",
  onHide,
  children,
  className,
  style,
  showCloseIcon = true,
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!visible) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape" && onHide) {
        onHide();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [visible, onHide]);

  if (!visible || !mounted) return null;

  const positionStyles = {
    right: "top-0 right-0 bottom-0 h-screen max-w-sm w-full animate-in slide-in-from-right duration-300 border-l border-urb-border",
    left: "top-0 left-0 bottom-0 h-screen max-w-sm w-full animate-in slide-in-from-left duration-300 border-r border-urb-border",
    top: "top-0 inset-x-0 max-h-96 w-full animate-in slide-in-from-top duration-300 border-b border-urb-border",
    bottom: "bottom-0 inset-x-0 max-h-96 w-full animate-in slide-in-from-bottom duration-300 border-t border-urb-border",
  };

  const sidebarNode = (
    <div className="fixed inset-0 z-[9999] overflow-hidden">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/70 backdrop-blur-sm transition-opacity"
        onClick={onHide}
      />

      {/* Slide-over panel */}
      <div
        style={style}
        className={cn(
          "fixed bg-urb-card shadow-2xl p-6 flex flex-col z-10 overflow-y-auto text-urb-text",
          positionStyles[position] || positionStyles.right,
          className
        )}
      >
        {showCloseIcon && onHide && (
          <button
            type="button"
            onClick={onHide}
            className="absolute top-4 right-4 z-20 p-2 text-urb-text-muted hover:text-white rounded-lg transition-colors cursor-pointer bg-transparent border-none"
            aria-label="Fechar"
          >
            <X className="w-5 h-5" />
          </button>
        )}
        {children}
      </div>
    </div>
  );

  return createPortal(sidebarNode, document.body);
};

export const Drawer = Sidebar;
export default Sidebar;

